// src/App.js
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from 'react-router-dom';

import SEO from './components/SEO'; // 👈 dynamic SEO

import LandingPage from './pages/LandingPage';
import DashboardLayout from './components/DashboardLayout';
import Dashboard from './components/Dashboard';
import ProtectedRoute from './middleware/ProtectedRoute';
import PublicRoute from './middleware/PublicRoute';

// Users & Hospital
import UserRoutes from './routes/UsersRoutes';
import DeviceSessions from './components/auth/DeviceSessions';
import HospitalRoutes from './routes/HospitalRoutes';

// CRM
import LeadsPage from './pages/crm/LeadsPage';
import ContactsPage from './pages/crm/ContactsPage';
import AccountsPage from './pages/crm/AccountsPage';
import OpportunitiesPage from './pages/crm/OpportunitiesPage';
import DealsPage from './pages/crm/DealsPage';
import CampaignsPage from './pages/crm/CampaignsPage';

// Enquiry
import AllEnquiriesPage from './pages/enquiry/AllEnquiriesPage';
import PendingEnquiriesPage from './pages/enquiry/PendingEnquiriesPage';
import FollowupEnquiriesPage from './pages/enquiry/FollowupEnquiriesPage';
import ConvertedEnquiriesPage from './pages/enquiry/ConvertedEnquiriesPage';

// HRMS
import EmployeesPage from './pages/hrms/EmployeesPage';
import AttendancePage from './pages/hrms/AttendancePage';
import LeaveManagementPage from './pages/hrms/LeaveManagementPage';
import PayrollPage from './pages/hrms/PayrollPage';
import RecruitmentPage from './pages/hrms/RecruitmentPage';
import PerformancePage from './pages/hrms/PerformancePage';
import TrainingPage from './pages/hrms/TrainingPage';
import TeamMembersPage from './pages/projects/Teammemberspage';

// Projects
import ProjectsPage from './pages/projects/ProjectsPage';
import TasksPage from './pages/projects/TasksPage';
import MilestonesPage from './pages/projects/MilestonesPage';
import GanttChartPage from './pages/projects/GanttChartPage';
import TimeTrackingPage from './pages/projects/TimeTrackingPage';
import SprintsPage from './pages/projects/SprintsPage';
import BugsPage from './pages/projects/BugsPage';

// Device Management
import AllCustomersPage from './pages/device-management/AllCustomersPage';
import AllDevicesPage from './pages/device-management/AllDevicesPage';
import AndroidDevicesPage from './pages/device-management/AndroidDevicesPage';
import iOSDevicesPage from './pages/device-management/iOSDevicesPage';
import DeviceGroupsPage from './pages/device-management/DeviceGroupsPage';
import DevicePoliciesPage from './pages/device-management/DevicePoliciesPage';
import AppManagementPage from './pages/device-management/AppManagementPage';
import DeviceTrackingPage from './pages/device-management/DeviceTrackingPage';
import RemoteActionsPage from './pages/device-management/RemoteActionsPage';
import DeviceAlertsPage from './pages/device-management/DeviceAlertsPage';
import DeviceInventoryPage from './pages/device-management/DeviceInventoryPage';
import WiFiProfilesPage from './pages/device-management/WiFiProfilesPage';
import OSUpdatesPage from './pages/device-management/OSUpdatesPage';
import ComplianceReportsPage from './pages/device-management/ComplianceReportsPage';

// White Labeling
import BrandSettingsPage from './pages/whitelabel/BrandSettingsPage';
import ThemeCustomizationPage from './pages/whitelabel/ThemeCustomizationPage';
import LogoManagementPage from './pages/whitelabel/LogoManagementPage';
import ColorSchemesPage from './pages/whitelabel/ColorSchemesPage';
import TypographyPage from './pages/whitelabel/TypographyPage';
import EmailTemplatesPage from './pages/whitelabel/EmailTemplatesPage';
import CustomDomainPage from './pages/whitelabel/CustomDomainPage';
import AppCustomizationPage from './pages/whitelabel/AppCustomizationPage';
import ClientConfigurationsPage from './pages/whitelabel/ClientConfigurationsPage';
import CustomCodePage from './pages/whitelabel/CustomCodePage';
import LandingPagesPage from './pages/whitelabel/LandingPagesPage';
import SEOSettingsPage from './pages/whitelabel/SEOSettingsPage';
import ProvisioningQRPage from './pages/whitelabel/ProvisioningQRPage';
import IntegrationBrandingPage from './pages/whitelabel/IntegrationBrandingPage';
import CompanyManagementPage from './pages/whitelabel/Companymanagementpage';

// Master Data
import ProductMasterPage from './pages/mdm/ProductMasterPage';
import CustomerMasterPage from './pages/mdm/CustomerMasterPage';
import VendorMasterPage from './pages/mdm/VendorMasterPage';
import LocationMasterPage from './pages/mdm/LocationMasterPage';
import CategoryMasterPage from './pages/mdm/CategoryMasterPage';


// Inventory
import InventoryRoutes from './routes/InventoryRoutes';
// import StockManagementPage from './pages/inventory/StockManagementPage';
// import PurchaseOrdersPage from './pages/inventory/PurchaseOrdersPage';
// import StockTransferPage from './pages/inventory/StockTransferPage';
// import StockAdjustmentPage from './pages/inventory/StockAdjustmentPage';

// Wallet
import WalletRoutes from './routes/WalletRoutes';
import Invoices from './pages/wallet/invoices';



// Sales
import QuotationsPage from './pages/sales/QuotationsPage';
import SalesOrdersPage from './pages/sales/SalesOrdersPage';
import InvoicesPage from './pages/sales/InvoicesPage';
import PaymentsPage from './pages/sales/PaymentsPage';

// Reports
import SalesReportsPage from './pages/reports/SalesReportsPage';
import HRReportsPage from './pages/reports/HRReportsPage';
import ProjectReportsPage from './pages/reports/ProjectReportsPage';
import DeviceReportsPage from './pages/reports/DeviceReportsPage';
import FinancialReportsPage from './pages/reports/FinancialReportsPage';
import CustomReportsPage from './pages/reports/CustomReportsPage';

// Communication
import MessagesPage from './pages/communication/MessagesPage';
import AnnouncementsPage from './pages/communication/AnnouncementsPage';
import NotificationsPage from './pages/communication/NotificationsPage';

// Settings
import CompanySettingsPage from './pages/settings/CompanySettingsPage';
import UserManagementPage from './pages/settings/UserManagementPage';
import RolesPermissionsPage from './pages/settings/RolesPermissionsPage';
import SystemSettingsPage from './pages/settings/SystemSettingsPage';
import IntegrationsPage from './pages/settings/IntegrationsPage';
import SubscriptionManagement from './components/SubscriptionManagement';
import ProfileSettings from './pages/settings/ProfileSettings';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import PrivacyPolicyWeb from './pages/PrivacyPolicyWeb';
import RefundPolicy from './pages/RefundPolicy';
// Help & Special
import HelpPage from './pages/HelpPage';
import MeetingRoom from './pages/MeetingRoom';
import NotFound from './pages/NotFound';
import ComingSoon from './pages/ComingSoon';
import MaintenanceMode from './pages/MaintenanceMode';
import MaintenanceWrapper from './components/MaintenanceWrapper';
/// app dounload page 
import AppDownloadPage from './pages/AppDownloadPage';
import DeviceOwnerQrGenerator from './pages/DeviceOwnerQrGenerator';
import AllInboxPage from './pages/settings/AllInboxPage';

// ─── Scroll handler ───────────────────────────────────────────
function ScrollHandler() {
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const section = params.get('section');

    if (section) {
      const element = document.getElementById(section);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 100);
      }
    } else if (location.pathname === '/') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [location]);

  return null;
}

// ─── App ──────────────────────────────────────────────────────
function App() {
  return (
    // ✅ HelmetProvider index.js mein hai — yahan nahi chahiye
    <MaintenanceWrapper>
      <Router>
        {/* ✅ SEO: route change hote hi title/meta auto update hoga */}
        <SEO />
        <ScrollHandler />

        <Routes>
          {/* ── Public Routes ── */}
          <Route
            path="/"
            element={
              <PublicRoute>
                <LandingPage />
              </PublicRoute>
            }
          />
          <Route path="/appdownload" element={<AppDownloadPage />} />
          <Route path="/dpc-policy" element={<PrivacyPolicyPage />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyWeb />} />
          <Route path="/coming-soon" element={<ComingSoon />} />
          <Route path="/meeting/:trainingId/:roomId" element={<MeetingRoom />} />
          <Route path="/device-owner-qr" element={<DeviceOwnerQrGenerator />} />
        

          {/* ── Protected Dashboard Routes ── */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <DashboardLayout />
              </ProtectedRoute>
            }
          >
            {/* Dashboard Home */}
            <Route index element={<Dashboard />} />

            {/* CRM */}
            <Route path="crm/leads"         element={<LeadsPage />} />
            <Route path="crm/contacts"      element={<ContactsPage />} />
            <Route path="crm/accounts"      element={<AccountsPage />} />
            <Route path="crm/opportunities" element={<OpportunitiesPage />} />
            <Route path="crm/deals"         element={<DealsPage />} />
            <Route path="crm/campaigns"     element={<CampaignsPage />} />
            

            {/* Enquiry */}
            <Route path="enquiry/all"       element={<AllEnquiriesPage />} />
            <Route path="enquiry/pending"   element={<PendingEnquiriesPage />} />
            <Route path="enquiry/followup"  element={<FollowupEnquiriesPage />} />
            <Route path="enquiry/converted" element={<ConvertedEnquiriesPage />} />

            {/* HRMS */}
            <Route path="hrms/employees"   element={<EmployeesPage />} />
            <Route path="hrms/attendance"  element={<AttendancePage />} />
            <Route path="hrms/leave"       element={<LeaveManagementPage />} />
            <Route path="hrms/payroll"     element={<PayrollPage />} />
            <Route path="hrms/recruitment" element={<RecruitmentPage />} />
            <Route path="hrms/performance" element={<PerformancePage />} />
            <Route path="hrms/training"    element={<TrainingPage />} />

            {/* Projects */}
            <Route path="projects/all"          element={<ProjectsPage />} />
            <Route path="projects/tasks"        element={<TasksPage />} />
            <Route path="projects/milestones"   element={<MilestonesPage />} />
            <Route path="projects/gantt"        element={<GanttChartPage />} />
            <Route path="projects/timetracking" element={<TimeTrackingPage />} />
            <Route path="projects/sprints"      element={<SprintsPage />} />
            <Route path="projects/bugs"         element={<BugsPage />} />
            <Route path="projects/team"         element={<TeamMembersPage />} />

            {/* Device Management */}
            <Route path="mdm/customer"      element={<AllCustomersPage />} />
            <Route path="mdm/devices"       element={<AllDevicesPage />} />
            <Route path="mdm/android"       element={<AndroidDevicesPage />} />
            <Route path="mdm/ios"           element={<iOSDevicesPage />} />
            <Route path="mdm/groups"        element={<DeviceGroupsPage />} />
            <Route path="mdm/policies"      element={<DevicePoliciesPage />} />
            <Route path="mdm/apps"          element={<AppManagementPage />} />
            <Route path="mdm/tracking"      element={<DeviceTrackingPage />} />
            <Route path="mdm/remote-actions" element={<RemoteActionsPage />} />
            <Route path="mdm/alerts"        element={<DeviceAlertsPage />} />
            <Route path="mdm/inventory"     element={<DeviceInventoryPage />} />
            <Route path="mdm/wifi"          element={<WiFiProfilesPage />} />
            <Route path="mdm/updates"       element={<OSUpdatesPage />} />
            <Route path="mdm/compliance"    element={<ComplianceReportsPage />} />

            {/* Wallet */}
            <Route path="wallet/invoices" element={<Invoices />} />
            <Route path="wallet/*"        element={<WalletRoutes />} />

            {/* Users */}
            <Route path="users/*" element={<UserRoutes />} />

            {/* Hospital */}
            <Route path="hospital/*" element={<HospitalRoutes />} />

            {/* White Labeling */}
            <Route path="whitelabel/branding"      element={<BrandSettingsPage />} />
            <Route path="whitelabel/themes"        element={<ThemeCustomizationPage />} />
            <Route path="whitelabel/logos"         element={<LogoManagementPage />} />
            <Route path="whitelabel/colors"        element={<ColorSchemesPage />} />
            <Route path="whitelabel/typography"    element={<TypographyPage />} />
            <Route path="whitelabel/email-templates" element={<EmailTemplatesPage />} />
            <Route path="whitelabel/domain"        element={<CustomDomainPage />} />
            <Route path="whitelabel/app"           element={<AppCustomizationPage />} />
            <Route path="whitelabel/clients"       element={<CompanyManagementPage />} />
            <Route path="whitelabel/custom-code"   element={<CustomCodePage />} />
            <Route path="whitelabel/landing-pages" element={<LandingPagesPage />} />
            <Route path="whitelabel/seo"           element={<SEOSettingsPage />} />
            <Route path="whitelabel/qr-pages"      element={<ProvisioningQRPage />} />
            <Route path="whitelabel/integrations"  element={<IntegrationBrandingPage />} />

            {/* Master Data */}
            <Route path="mdm/products"   element={<ProductMasterPage />} />
            <Route path="mdm/customers"  element={<CustomerMasterPage />} />
            <Route path="mdm/vendors"    element={<VendorMasterPage />} />
            <Route path="mdm/locations"  element={<LocationMasterPage />} />
            <Route path="mdm/categories" element={<CategoryMasterPage />} />

            {/* Inventory */}
            <Route path="inventory/*" element={<InventoryRoutes />} />
            {/* <Route path="inventory/stock"           element={<StockManagementPage />} />
            <Route path="inventory/purchase-orders" element={<PurchaseOrdersPage />} />
            <Route path="inventory/transfer"        element={<StockTransferPage />} />
            <Route path="inventory/adjustment"      element={<StockAdjustmentPage />} /> */}

            {/* Sales */}
            <Route path="sales/quotations" element={<QuotationsPage />} />
            <Route path="sales/orders"     element={<SalesOrdersPage />} />
            <Route path="sales/invoices"   element={<InvoicesPage />} />
            <Route path="sales/payments"   element={<PaymentsPage />} />

            {/* Reports */}
            <Route path="reports/sales"      element={<SalesReportsPage />} />
            <Route path="reports/hr"         element={<HRReportsPage />} />
            <Route path="reports/projects"   element={<ProjectReportsPage />} />
            <Route path="reports/devices"    element={<DeviceReportsPage />} />
            <Route path="reports/financial"  element={<FinancialReportsPage />} />
            <Route path="reports/custom"     element={<CustomReportsPage />} />

            {/* Communication */}
            <Route path="communication/messages"      element={<MessagesPage />} />
            <Route path="communication/announcements" element={<AnnouncementsPage />} />
            <Route path="communication/notifications" element={<NotificationsPage />} />

            {/* Settings */}
            <Route path="settings/company"      element={<CompanySettingsPage />} />
            <Route path="settings/users"        element={<UserManagementPage />} />
            <Route path="settings/roles"        element={<RolesPermissionsPage />} />
            <Route path="settings/system"       element={<SystemSettingsPage />} />
            <Route path="settings/integrations" element={<IntegrationsPage />} />
            <Route path="settings/sessions"     element={<DeviceSessions />} />
            <Route path="settings/profile" element={<ProfileSettings />} />




            {/* Subscription */}
            <Route path="subscriptions" element={<SubscriptionManagement />} />

            {/* Help */}
            <Route path="help" element={<HelpPage />} />
          </Route>

          {/* 404 */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </MaintenanceWrapper>
  );
}

export default App;